import React from 'react'
import Footer from '../Components/Footer'
import ContactForm from '../Components/ContactForm'


function Faq(){
    return(
        <div>
           
            <ContactForm/>
            <Footer/>
        </div>
    )
}
export default Faq